// extracted by mini-css-extract-plugin
export var hideEditor = "_sa-2";
export var infoIcon = "_sa-3";
export var label = "_sa-1";
export var labelContainer = "_sa-0";
export var readonlyText = "_sa-4";